<template>
  <div class="service-pick">
    <!-- 顶部菜单栏 -->
  <div class="tab-bar">
    <!-- 服务信息标签 -->
    <span v-if="showServiceBtn" class="tab-label">服务信息（{{ serviceTotalCount }}）</span>

    <!-- 领料信息标签 -->
    <span v-if="showPickBtn" class="tab-label">领料信息（{{ pickTotalCount }}）</span>
  </div>

    <!-- 普通表格（滚动） -->
    <div class="table-box">
      <card-table
        :tableID="tableId"
        :tableData="currentList"
        :tableColumn="currentColumns"

        :mobileColumns="mobiletaskColumns"

        :showPaging="false"
        :height="'100%'"
        tooltip-popper-class="after-sale-tooltip"
      />
    </div>
  </div>
</template>

<script>
export default {
  name: 'serviceAndPick',
props: {
  serviceList: Array,
  pickList: Array,
  tableId: { type: String, default: 'serviceAndPick' },
  serviceTotalCount: {
    type: Number,
    // default: 0
  },
  pickTotalCount: {
    type: Number,
    // default: 0
  }
},

watch: {
  hasService() {
    this.fixActiveTab();
  },
  hasPick() {
    this.fixActiveTab();
  }
},

created() {
  this.fixActiveTab();
},
  data() {
    return {
      activeTab: 'service', // service | pick

      serviceColumns: [
        // { prop: '合同编号', label: '合同编号' },
        // { prop: '客户单位', label: '客户单位' },
        { prop: '产品型号', label: '产品型号' },
        // { prop: '销售员', label: '销售员' },
        // { prop: '责任人', label: '责任人' },
        { prop: '约定到达日期', label: '约定到达日期' },
        { prop: '到场日期', label: '到场日期' },
        { prop: '离场日期', label: '离场日期' },
        { prop: '计划完成日期', label: '计划完成日期' },
        { prop: '余留问题', label: '余留问题' },
        { prop: '服务记录', label: '服务记录' },
        // { prop: '地址', label: '地址' },
        // { prop: '进度', label: '进度' }
      ],

      mobileserviceColumns: [
        '产品型号',
        '约定到达日期',
        '到场日期',
        '离场日期',
        '计划完成日期',
        '余留问题',
        '服务记录',

      ],

      pickColumns: [
        // { prop: '合同编号', label: '合同编号' },
        { prop: '物料名称', label: '物料名称' },
        { prop: '短代码', label: '短代码' },
        // { prop: '出库单号', label: '出库单号' },
        { prop: '出库数量', label: '出库数量' },
        { prop: '领料原因', label: '领料原因' },
        { prop: '描述', label: '描述' },
        // { prop: '运单号', label: '运单号' },
        { prop: '可用库存', label: '可用库存' },
        { prop: '是否返厂', label: '是否返厂' },
        // { prop: '发起人', label: '发起人' },
        // { prop: '申请人', label: '申请人' },
        // { prop: '用户单位', label: '用户单位' },
        // { prop: '收货地址', label: '收货地址' },
        // { prop: '进度', label: '进度' }
      ],

      mobilepickColumns: [
        '合同编号',
        '物料名称',
        '出库单号',
        '出库数量',
        '领料原因',
        '可用库存',
        '是否返厂',
        '用户单位',
        '收货地址',
      ],
    }
  },
computed: {
  hasService() {
    return (this.serviceTotalCount || 0) > 0;
  },
  hasPick() {
    return (this.pickTotalCount || 0) > 0;
  },

  /** 是否显示服务按钮 */
  showServiceBtn() {
    return this.hasService;
  },

  /** 是否显示领料按钮 */
  showPickBtn() {
    // 有领料，或两个都没有
    return this.hasPick || (!this.hasService && !this.hasPick);
  },

  currentList() {
    if (this.activeTab === 'service') {
      return this.formattedServiceList;
    }
    return this.pickList;
  },

  /** 服务列表：日期字段只保留年月日 */
  formattedServiceList() {
    if (!this.serviceList || !this.serviceList.length) return [];
    const dateFields = ['约定到达日期', '到场日期', '离场日期', '计划完成日期'];
    return this.serviceList.map(item => {
      const newItem = { ...item };
      dateFields.forEach(field => {
        if (newItem[field]) {
          const str = String(newItem[field]);
          newItem[field] = str.length >= 10 ? str.slice(0, 10) : str;
        }
      });
      return newItem;
    });
  },

  currentColumns() {
    return this.activeTab === 'service'
      ? this.serviceColumns
      : this.pickColumns;
  },

  mobiletaskColumns() {
    return this.activeTab === 'service'
      ? this.mobileserviceColumns
      : this.mobilepickColumns;
  }
},


methods: {
fixActiveTab() {
  const { hasService, hasPick } = this;

  // ✅ 只有服务
  if (hasService && !hasPick) {
    this.activeTab = 'service';
    return;
  }

  // ✅ 只有领料
  if (!hasService && hasPick) {
    this.activeTab = 'pick';
    return;
  }

  // ✅ 两个都有：默认选中服务
  if (hasService && hasPick) {
    this.activeTab = 'service';
    return;
  }

  // ✅ 两个都没有
  this.activeTab = 'pick';
}
}


}
</script>

<style scoped lang="scss">
.service-pick {
  display: flex;
  flex-direction: column;
  overflow: hidden; // ✅ 防止整体滚
  height: 100%;

  .tab-bar {
    flex-shrink: 0;
    padding: 4px;
    border-bottom: 1px solid #ebeef5;
    display: flex;
    gap: 8px;

    .tab-label {
      display: inline-block;
      padding: 0 12px;
      line-height: 28px;
      font-size: 12px;
      border-radius: 3px;
      background-color: transparent;
      color: #303133;
      cursor: default;
      user-select: none;
    }
  }

  .table-box {
    flex: 1;
    min-height: 0;
    overflow: hidden;
    position: relative;
  }

  /* ✅ 强制 card-table 滚动 */
  ::v-deep .card-table {
    height: 100%;
    overflow: auto;
  }

    /* 这句话起的作用让表格高度都一致 的 el-table */
  ::v-deep .el-table {
    height: 100% !important;
  }



  ::v-deep .el-table__body-wrapper {
    overflow-y: auto !important;
    overflow-x: auto !important;
  }
}

</style>

<!-- ⚠️ 这段必须「不带 scoped」：
     el-tooltip 的 popper 是 appendToBody 挂到 <body> 上的（Element 默认 appendToBody: true），
     既没有本组件的 data-v 属性、也不在 .service-pick / .card-table 结构里，
     所以组件内任何 scoped / ::v-deep 规则都命中不了它 → 长文本的 tooltip 无限宽，
     左边超出浏览器窗口，开头的文字看不到。
     这里用 card-table 新增的 tooltipPopperClass 传进来的类名精确定位，
     限制宽度并允许换行，内容就完整显示在页面内了。 -->
<style lang="scss">
.el-tooltip__popper.after-sale-tooltip {
  /* ⚠️ 别直接写 min(70vw, 460px)：dart-sass 会把它当成自己的 min() 去比较单位，
     报 "Incompatible units: 'px' and 'vw'"。用 unquote 让它原样输出给浏览器 */
  max-width: 460px !important;                            /* 老浏览器兜底 */
  max-width: unquote("min(70vw, 460px)") !important;      /* 先限宽 */
  white-space: normal !important;           /* 再允许换行 */
  word-break: break-word !important;
  line-height: 1.5 !important;
  padding: 6px 10px !important;
  text-align: left !important;
}

/* 手机端：再宽也只在屏幕内，不横向溢出 */
@media screen and (max-width: 768px) {
  .el-tooltip__popper.after-sale-tooltip {
    max-width: 86vw !important;
    font-size: 12px !important;
    line-height: 1.4 !important;
  }
}
</style>
